import { languageObject } from "assets/data/languages";
import { Button, IconInput, SVG, Switch } from "ui";
import { CustomComponentProps } from "utils/types/generalTypes";

import { languagesArray } from "assets/data/languages";
import { useEffect, useState } from "react";

export type LanguageModalProps = CustomComponentProps & {
    opened: boolean;
    selectedLanguages: languageObject[];
    closeLangModal: React.Dispatch<React.SetStateAction<boolean>>;
    toggleLang: Function;
};

const LanguageModal = ({
    opened,
    selectedLanguages,
    closeLangModal,
    toggleLang
}: LanguageModalProps) => {
    const [filter, setFilter] = useState("");
    const [filteredLangArr, setFilteredLangArr] =
        useState<languageObject[]>(languagesArray);

    const handleChangeFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter(e.target.value);
        const filteredArr = languagesArray.filter(
            (i) =>
                i.name.toLowerCase().indexOf(e.target.value) > -1 ||
                i.nativeName.toLowerCase().indexOf(e.target.value) > -1
        );
        setFilteredLangArr(filteredArr);
    };

    const [disableSwitchsClass, setDisableSwtchsClass] = useState(false);

    useEffect(() => {
        setDisableSwtchsClass(selectedLanguages.length >= 4);
    }, [selectedLanguages]);

    return (
        <div
            id="language-modal"
            className={`modal share-modal is-xsmall has-light-bg ${opened ? "is-active" : ""}`}
        >
            <div className="modal-background"></div>
            <div className="modal-content">
                <div className="card">
                    <div className="card-heading flex-a-start">
                        <div>
                            <h3>Choose Languages</h3>
                            <p className="momeento-p">
                                You can select up to four languages to explore
                                your posts and incidents to all users who speak
                                same language you selected.
                            </p>
                        </div>

                        {/* <!-- Close X button --> */}
                        <div className="close-wrap">
                            <span
                                className="close-modal"
                                onClick={() => closeLangModal(false)}
                            >
                                <SVG
                                    svg="x"
                                    size={16}
                                    className="light-grey-svg"
                                />
                            </span>
                        </div>
                    </div>

                    <div className="card-body">
                        <div className="control">
                            <IconInput
                                value={filter}
                                handleChange={handleChangeFilter}
                                rounded={true}
                            />

                            <ul id="lang-ul">
                                {filteredLangArr.map((lang) => (
                                    <li
                                        key={lang.code}
                                        className="lang-li d-flex flex-j-between pl-10 gap-10"
                                    >
                                        <span className="lang-span fw-500 white-text">
                                            {lang.name} ({lang.nativeName})
                                        </span>
                                        {selectedLanguages.includes(lang) ? (
                                            <Switch
                                                handleClick={() =>
                                                    toggleLang(lang)
                                                }
                                                checked={true}
                                            />
                                        ) : (
                                            <Switch
                                                handleClick={() =>
                                                    toggleLang(lang)
                                                }
                                                disabled={disableSwitchsClass}
                                                checked={false}
                                            />
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    <div className="card-footer d-flex flex-j-end">
                        <div className="button-wrap">
                            <Button
                                text="close"
                                className="dark-grey-button close-modal"
                                handleClick={() => closeLangModal(false)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LanguageModal;
